export default __webpack_public_path__ + "static/media/IMG_2193.3ca7bf0c.jpg";